import { AuthProvider } from './../../providers/auth/auth';
import { TasksPage } from './../tasks/tasks';
import { InstallerTasksPage } from './../installer-tasks/installer-tasks';
import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController, AlertController } from 'ionic-angular';
import { HttpErrorResponse } from '@angular/common/http';
import { UtilsProvider } from '../../providers/utils/utils';
import { LocationProvider } from '../../providers/location/location';

@IonicPage()
@Component({
  selector: 'page-login',
  templateUrl: 'login.html'
})
export class LoginPage {
  private username: string;
  private password: string;
  private authcode: string;
  private loader: any;
  private logingIn: boolean = false;
  private showMfa: boolean = false;
  private isReset: boolean = false;
  private isReVerify: boolean = false;

  constructor(
    public navCtrl: NavController,
    public authProvider: AuthProvider,
    public alertCtrl: AlertController,
    public loadingCtrl: LoadingController,
    private utilsProvider: UtilsProvider,
    private locationProvider: LocationProvider
  ) {
    this.utilsProvider.checkVersion();
  }

  ionViewDidLoad() {
    this.presentLoading();
    this.authProvider.checkUser().subscribe(
      data => {
        if (data) {
          this.authProvider.registerFCM().subscribe(
            r => {
              // this should not stop if registering the FCM fails
              console.log('Success on FCM register', r);
            },
            e => {
              // debug error
              console.log('Error on FCM register: ', e);
            }
          );
          const isScheduler = this.authProvider.userData.isSchedular;
          const startPage = isScheduler? TasksPage: InstallerTasksPage;
          this.locationProvider.getLocation().subscribe(position => {
            // init position
            this.loader.dismiss();
            this.navCtrl.setRoot(startPage, {
              animate: true,
              direction: 'forward'
            });
          })
        }
      },
      errorResult => {

        console.log('ERROR on login:: ', errorResult);

        if(errorResult.error && !errorResult.error.message){
          let  message = 'Failed to login, please check your details and try again.';

          let alert = this.alertCtrl.create({
            title: 'Error!',
            message: message,
            buttons: ['OK']
          });
          alert.present();
        }
        this.loader.dismiss();
        },
        () => {
          if(!this.loader._isHidden) this.loader.dismiss();
        }
    );
  }
  presentLoading() {
    this.loader = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    this.loader.present();
  }

  resendVerification(){
    this.authProvider.verificationResend(this.username).subscribe(
      data => {
        this.logingIn = false;

        let message = 'An email was sent to, ' + this.username + ', to reverify your account.';
        let alert = this.alertCtrl.create({
          title: 'Reverify Email',
          message: message,
          buttons: ['OK']
        });
        alert.present();
        this.resetToLogin()
      },
      (error: HttpErrorResponse) => {
        this.logingIn = false;
        console.log(error)
        let message = error.error && error.error.message ? error.error.message : 'other message';//error.message ? error.message : 'Failed to reverify, please check your details and try again.';
        let alert = this.alertCtrl.create({
          title: 'Error!',
          message: message,
          buttons: ['OK']
        });
        alert.present();
      }
    );


  }
  resetToLogin(){
    this.isReVerify = false;
    this.isReset = false;
  }
  forgotPassword() {
    this.logingIn = true;
    this.authProvider.forgotPassword(this.username).subscribe(
      data => {
        this.logingIn = false;
        //this.navCtrl.setRoot(Tasks, { animate: true, direction: 'forward' });
        let message = 'An email was sent to, ' + this.username + ', to assist in resetting your password.';

        if (data?.error) message = data.error?.message
        
        let alert = this.alertCtrl.create({
          title: 'Forgot password',
          message: message,
          buttons: ['OK']
        });
        alert.present();
      },
      error => {
        this.logingIn = false;
        let message = error.message ? error.message : 'Failed to reset password, please check your details and try again.';
        let alert = this.alertCtrl.create({
          title: 'Error!',
          message: message,
          buttons: ['OK']
        });
        alert.present();
      }
    );
  }

  login() {
    this.logingIn = true;

    this.presentLoading();
    this.authProvider.loginUser(this.username, this.password, this.authcode).subscribe(
      data => {
        this.logingIn = false;
        this.loader.dismiss();
        this.authProvider.registerFCM().subscribe(
          r => {
            // this should not stop if registering the FCM fails
            console.log('Success on FCM register', r);
          },
          e => {
            // debug error
            console.log('Error on FCM register: ', e);
          }
        );
        const startPage = this.authProvider.userData.isSchedular? TasksPage: InstallerTasksPage;
        this.navCtrl.setRoot(startPage, {
          animate: true,
          direction: 'forward'
        });
      },
      (errorResult: HttpErrorResponse) => {
        this.loader.dismiss();
        this.logingIn = false;
        console.log(errorResult);
        if (errorResult.error && errorResult.error.error === '2fa_required') {
          this.showMfa = true;
          let message = 'Enter your two factor authentication code';
          let alert = this.alertCtrl.create({
            title: 'Authentication',
            message: message,
            buttons: ['OK']
          });
          alert.present();
          // this.authcode = '1';
          // this.login();
        } else {
          let message =
            errorResult.error && errorResult.error
              ? errorResult.error.message
              : 'Failed to login, please check your details and try again.';

          if (errorResult.status === 0) message = 'No internet connection found.';
          let alert = this.alertCtrl.create({
            title: 'Error!',
            message: message,
            buttons: ['OK']
          });
          alert.present();
          if(errorResult.error.error === "2fa_invalid") this.authcode = null;
        }
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts